<section class="section white-100" *ngIf="caseOtherFeatureData">
    <div class="section-container-inside">
        <h2 class="section-heading mar-b-48">
            {{caseOtherFeatureData?.title}}
        </h2>
        <div class="content-section">
            <div class="content-left">
                <div [innerHTML]="caseOtherFeatureData?.content | toHtml"></div>
            </div>
            <div class="content-right">
                <img
                  loading="lazy"
                  class="mar-l-8"
                  src="{{ caseOtherFeatureData?.image?.[0]?.fields?.file?.url }}"
                  alt=""
                />
            </div>
        </div>
    </div>
</section>
